import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAreas } from "../../../../redux/reducer/areaReducer";
import DetailsRow from "./DetailsRow";
import EditForm from "./EditForm";
import PriceForm from "./PriceForm";
import { useTranslation } from "react-i18next";
import {
  updateProduct,
  updateProductPricing,
} from "../../../../redux/reducer/productReducer";
import GalleryImagesForm from "../../GalleryImagesForm";

const DetailsTable = ({
  details,
  onDelete,
  onUpdate,
  isEditing,
  isGalleryEditing,
  isPricing,
  setEditingOrder,
  setPricingOrder,
  setGalleryEditingOrder,
  refreshData,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { areas, loadingAreas } = useSelector((state) => state.areas);
  // State for price form and edit form
  const [priceForm, setPriceForm] = useState({
    name: details.nameProduct || "",
    area: details?.area || "",
  });

  const [editForm, setEditForm] = useState({
    name: details.nameProduct || "",
    price: "",
    DShippingFees: "",
    area: details?.area || "",
  });
  useEffect(() => {
    dispatch(fetchAreas());
  }, [dispatch]);

  const getLinkButton = (url) => {
    try {
      const hostname = new URL(url).hostname;
      const parts = hostname.split(".");
      const text = parts[1] || hostname;
      return (
        <button
          onClick={() => window.open(url, "_blank")}
          className="px-2 py-1 font-bold text-black duration-300 rounded bg-custom-yellow hover:bg-yellow-200"
        >
          {text}
        </button>
      );
    } catch {
      return "Invalid Link";
    }
  };

  const handleEdit = () => {
    setEditForm({
      name: details.nameProduct || "",
      price: "",
      DShippingFees: "",
      area: details?.area || "",
    });
    setEditingOrder(details.id);
    setPricingOrder(null);
  };

  const handlePrice = () => {
    setPriceForm({
      name: details?.nameProduct || "",
      price: details.price || "",
      DShippingFees: details.DShippingFees || "",
      area: details.area || "",
    });
    setPricingOrder(details.id);
    setEditingOrder(null);
  };

  const handleGalleryEdit = () => {
    setGalleryEditingOrder(details.id);
    setEditingOrder(null);
    setPricingOrder(null);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const handlePriceChange = (e) => {
    const { name, value } = e.target;
    setPriceForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();
    // console.log(editForm)
    dispatch(updateProduct({ id: details.id, data: editForm }))
      .unwrap()
      .then(() => {
        if (onUpdate) onUpdate(editForm);
        refreshData();
      });
    setEditingOrder(null);
  };

  const handlePriceSubmit = (e) => {
    e.preventDefault();
    // console.log(priceForm)
    if (
      !priceForm.name ||
      !priceForm.price ||
      !priceForm.DShippingFees ||
      !priceForm.area
    ) {
      alert(t("priceRequired"));
      return;
    }

    // Add default values if they are not already set
    const finalForm = {
      ...priceForm,
    };

    // console.log("Final priceForm JSON data:", finalForm);

    dispatch(updateProductPricing({ id: details.id, data: finalForm }))
      .unwrap()
      .then(() => {
        if (refreshData) refreshData();
      });
    setPricingOrder(null);
  };

  // console.log(details)
  return (
    <>
      <DetailsRow
        details={details}
        onDelete={onDelete}
        areas={areas}
        onPrice={handlePrice}
        onGallery={handleGalleryEdit}
        onEdit={handleEdit}
        getLinkButton={getLinkButton}
      />
      {(isPricing || isEditing || isGalleryEditing) && (
        <div>
          <div className="absolute top-0 left-0 h-full w-full p-4 bg-black bg-opacity-5 z-[100]">
            {isEditing ? (
              <EditForm
                editForm={editForm}
                onChange={handleEditChange}
                onSubmit={handleEditSubmit}
                onCancel={() => setEditingOrder(null)}
                areas={areas}
                loadingAreas={loadingAreas}
              />
            ) : isPricing ? (
              <PriceForm
                priceForm={priceForm}
                onChange={handlePriceChange}
                onSubmit={handlePriceSubmit}
                onCancel={() => setPricingOrder(null)}
                areas={areas}
                loadingAreas={loadingAreas}
              />
            ) : (
              <GalleryImagesForm
                productId={details.id}
                images={details.images || []}
                refreshData={refreshData}
                onCancel={() => setGalleryEditingOrder(null)}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default DetailsTable;
